module.exports = __webpack_public_path__ + "static/img/eyebrows_04.bc00489.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyebrows/thumbnail/eyebrows_04.png
// module id = ucSq
// module chunks = 0